import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Card from '../../components/Card'
import Grid from '../../components/Grid'
import Toggle from '../../components/Toggle'
import patient from '../../stores/patient'

const toggles = [
  'SPORTS',
  'MUSIC',
  'WRITING',
  'READING',
  'MATH',
  'SCIENCE',
  'LANGUAGES',
  'THEATER',
  'SINGING',
  'ART',
  'GAMES',
  'COOKING',
  'MY_JOB',
  'MONEY_MANAGEMENT',
  'FIXING_THINGS',
  'COMMUNICATING_WITH_OTHERS',
  'CARE_OF_OTHERS',
  'RELIGIOUS_OBSERVATION',
  'HOUSE_WORK',
  'FASHION',
  'DRIVING',
  'SHOPPING',
]

@observer
export default class StrengthToggles extends Component {
  render() {
    return (
      <Card>
        <Card.Pad>
          <Grid>
            {toggles.map((v, i) => (
              <Grid.HalfCell key={i}>
                <Toggle
                  color="red"
                  checked={patient.fields.strengths.includes(v)}
                  value={v}
                  str={`choices.strength.${v}`}
                  onToggle={patient.toggleStrength}
                />
              </Grid.HalfCell>
            ))}
          </Grid>
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Goal/StrengthToggles.js